module.exports = __webpack_public_path__ + "img/The traditional approach- .49645b71.png";